
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Es gibt tatsächlich Studien, die solche Unterschiede aufzeigen. Zum Beispiel schlafen Frauen im Schnitt länger als Männer, wenn man sie lässt. Sie leiden zudem öfter unter Schlafstörungen als Männer. Wieso das so ist, weiss man nicht genau. Die Unterschiede können sowohl psychologische, gesundheitliche als auch soziologische Ursachen haben. Für einen guten Schlaf müssen wir entspannt sein – emotional wie körperlich. `}<M mdxType="M">{`Gerade Frauen können aber tendenziell weniger gut abschalten und Sorgen verdrängen.`}</M>{` `}<br /><br />{`
Zudem gibt es im Leben vieler Frauen zwei Phasen, die Schlafprobleme begünstigen: die Geburt eines Kindes und die Wechseljahre. Mütter leiden nach der Geburt in der Regel häufiger an Schlafstörungen als Väter. Dies liegt gemäss der Psychologin Sakari Lemola daran, dass sie nach wie vor häufiger die primären Bezugspersonen sind. Im Schnitt schlafen Frauen in den ersten drei Monaten nach der Geburt ihres Babys eine Stunde weniger als davor. Bei den Vätern sind es 15 Minuten weniger. Ein weiterer Grund für die Schlaflosigkeit von Frauen könnte aber auch der Geräuschpegel ihrer schlafenden Partner sein: Die meisten Männer schnarchen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;